module.exports = __webpack_public_path__ + "img/cert_4.b4ab9377.jpg";